import {
  fetch_nomination,
} from '@/plugins/fetch';

import configuration from '@/configurations';

class AiRepository {
  /**
   * Generic safe endpoint to ask a business case template
   * @param {string} business_case - Business case name
   * @param {object} variables - template replacement variables (vary by template)
   * @param {object} options - prompt options
   * @param {number} options.max_tokens - max tokens to generate
   * @param {string} options.model - AI model to use
   * @param {number} options.n - number of responses to generate
   * @param {number} options.stream - stream response (default: false)
   * @param {number} options.temperature - temperature setting for generation
   * @returns
   */
  async askBusinessCase(business_case, variables = {}, options = {}) {
    const data = {
      variables,
      options,
    };

    const config = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (options.stream) {
      config.headers = {
        ...config.headers,
        Accept: 'application/x-ndjson',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive',
      };
    }

    const res = await fetch_nomination(
      `${configuration.api_host}/v1/ai/chat/ask/business-case/${business_case}`,
      config
    );

    if (!res.ok) {
      throw new Error('Error generating value proposition', res);
    }

    return res;
  }
}

const ai_repository = new AiRepository();

export {
  ai_repository,
};
